import React from 'react';
import { EmployeeRole } from 'types';
import { RoleActions } from './roleActions';

// Messaging for successfully claiming an invitation without the need for a review.
const addDebitLanguage = 'Be sure to enter your debit card if you wish to receive payments.';

export const messagingSuccess = (messageRole?: EmployeeRole, messageEntity?: string, isMultiInvite?: boolean) => {
  if (isMultiInvite) return <span data-cy="messaging-accepted-multi">Thank you for accepting your invitations. You can now access your new roles. {addDebitLanguage}</span>;

  if (messageRole === EmployeeRole.EMPLOYEE) {
    return (
      <span data-cy="messaging-accepted-employee">
        You are now connected to <strong>{messageEntity}</strong>. Be sure to enter your debit card to {RoleActions.EMPLOYEE}.
      </span>
    );
  }

  if (messageRole === EmployeeRole.MANAGER) {
    return (
      <span data-cy="messaging-accepted-manager">
        You are now a manager of <strong>{messageEntity}</strong>. You can {RoleActions.MANAGER}. {addDebitLanguage}
      </span>
    );
  }

  if (messageRole === EmployeeRole.SITE_ADMIN) {
    return (
      <span data-cy="messaging-accepted-siteadmin">
        You are now a site administrator for <strong>{messageEntity}</strong>. You can {RoleActions.SITE_ADMIN}. {addDebitLanguage}
      </span>
    );
  }

  if (messageRole === EmployeeRole.ADMIN) {
    return (
      <span data-cy="messaging-accepted-admin">
        You are now an administrator for <strong>{messageEntity}</strong>. You can {RoleActions.ADMIN}. {addDebitLanguage}
      </span>
    );
  }

  return null;
};
